import { createGtm, type VueGtmUseOptions } from '@gtm-support/vue-gtm'

type GtmRuntimeOptions = Omit<VueGtmUseOptions, 'vueRouter'> & { enableRouterSync?: boolean }

/**
 * In-house replacement for @zadigetvoltaire/nuxt-gtm (abandoned, Nuxt 3 only).
 * Registers @gtm-support/vue-gtm with the same options and router sync the
 * wrapper module used; options stay under runtimeConfig.public.gtm, so
 * NUXT_PUBLIC_GTM_* runtime overrides keep working.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const options = useRuntimeConfig().public.gtm as GtmRuntimeOptions
  const router = useRouter()

  nuxtApp.vueApp.use(
    createGtm({
      ...options,
      vueRouter: options.enableRouterSync && router ? (router as VueGtmUseOptions['vueRouter']) : undefined,
    }),
  )
})
